import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { API_VERSION, PACKAGES_PATH } from '../constants/RestApiConstants';

export class DeletePackageService {
  public static deletePackage(packageLuid: string): Promise<void> {
    return makeJsonRestApiRequest<void, void>({
      config: {
        restApiVersion: API_VERSION,
        httpMethod: 'DELETE',
        endpoint: `${PACKAGES_PATH}/${packageLuid}`,
      },
      request: null,
    });
  }
}
